import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";

import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr } from "date-fns/locale";
import moment from "moment";

// Material Dashboard 2 PRO React components
import MDTypography from "../../../components/MDTypography";
import MDInput from "../../../components/MDInput";
import MDBox from "../../../components/MDBox";

import Tooltip from "@mui/material/Tooltip";

import { statusEnum, situationDescriptionEnum } from "../../../config/enum";
import { useEffect } from "react";

export default function BillingInfos({
  user,
  situationDescription,
  setSituationDescription,
  situationDate,
  setSituationDate,
  waitingDate,
  setWaitingDate,
  startWaitingDate,
  billNumber,
  setBillNumber,
  requirePercentage,
  setRequirePercentage,
  status,
  setStatus,
}) {
  const handleStatusChange = (newStatus) => {
    setStatus(newStatus);
    if (newStatus === "Facturée") {
      setSituationDate(moment(new Date()).format("YYYY-MM-DD"));
    }
    if (newStatus === "À facturer") {
      setWaitingDate(moment(new Date()).format("YYYY-MM-DD"));
    }
  };

  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Tooltip
            title={
              user && user.role === "Contremaître"
                ? "Vous n'avez pas les droits pour modifier cette information"
                : ""
            }
            placement="top"
          >
            <Autocomplete
              freeSolo
              disabled={user && user.role === "Contremaître"}
              options={situationDescriptionEnum}
              value={situationDescription}
              required
              onInputChange={(event, newInputValue) => {
                setSituationDescription(newInputValue);
              }}
              onChange={(event, newSituationDescription) => {
                if (newSituationDescription) {
                  setSituationDescription(newSituationDescription);
                }
              }}
              renderInput={(params) => (
                <MDInput
                  {...params}
                  label="Description de la situation de facturation"
                  variant="standard"
                />
              )}
            />
          </Tooltip>
        </Grid>
        <Grid item xs={status === "Facturée" ? "3" : status === "À facturer" ? "2.5" : "6"}>
          <Autocomplete
            options={statusEnum}
            value={status}
            onChange={(event, newStatus) => {
              handleStatusChange(newStatus);
            }}
            renderInput={(params) => (
              <MDInput {...params} label="Choisissez le statut" variant="standard" />
            )}
          />
        </Grid>
        {(status === "Facturée" || status === "À facturer") && (
          <Grid item container xs={status === "À facturer" ? "3.5" : "3"}>
            <Grid
              item
              xs={status === "À facturer" ? "3.5" : "1.5"}
              display="flex"
              alignItems="center"
            >
              <MDTypography variant="body2">
                {status === "À facturer" ? "depuis le" : "le"}
              </MDTypography>
            </Grid>
            {status === "À facturer" && (
              <Grid item xs={8.5}>
                <Tooltip
                  title={startWaitingDate !== null ? "Vous ne pouvez pas modifier cette date" : ""}
                  placement="top"
                >
                  <Stack component="form" required noValidate>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                      <DatePicker
                        displayWeekNumber
                        label="Choisissez la date"
                        value={waitingDate && new Date(waitingDate)}
                        onChange={(newValue) => {
                          if (newValue === null) {
                            setWaitingDate(null);
                          } else setWaitingDate(moment(newValue).format("YYYY-MM-DD"));
                        }}
                        disabled={startWaitingDate !== null}
                        renderInput={(params) => <TextField {...params} fullWidth />}
                        format="dd/MM/yyyy"
                      />
                    </LocalizationProvider>
                  </Stack>
                </Tooltip>
              </Grid>
            )}
            {status === "Facturée" && (
              <Grid item xs={10.5}>
                <Stack component="form" required noValidate>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                    <DatePicker
                      displayWeekNumber
                      label="Choisissez la date"
                      value={situationDate && new Date(situationDate)}
                      onChange={(newValue) => {
                        if (newValue === null) {
                          setSituationDate(null);
                        } else setSituationDate(moment(newValue).format("YYYY-MM-DD"));
                      }}
                      renderInput={(params) => <TextField {...params} fullWidth />}
                      format="dd/MM/yyyy"
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>
            )}
          </Grid>
        )}
        <Grid item xs={6}>
          <Tooltip
            title={
              user && user.role === "Contremaître"
                ? "Vous n'avez pas les droits pour modifier cette information"
                : ""
            }
            placement="top"
          >
            <TextField
              fullWidth
              inputProps={{ maxLength: 255 }}
              disabled={user && user.role === "Contremaître"}
              value={requirePercentage}
              onChange={(event) => setRequirePercentage(event.target.value)}
              required
              variant="standard"
              type="number"
              label="Pourcentage requis"
            />
          </Tooltip>
        </Grid>
        {status === "Payée" || status === "Partiellement payée" || status === "Facturée" ? (
          <Grid item xs={6}>
            <FormField
              inputProps={{ maxLength: 255 }}
              value={billNumber}
              onChange={(event) => setBillNumber(event.target.value)}
              required
              variant="standard"
              type="text"
              label="Numéro de la facture"
            />
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
    </MDBox>
  );
}
